// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiMessageOutline } from "@mdi/js";
import { List } from "antd";
import styled from "styled-components";

import { BusyIndicator } from "components/activity/shared";
import { Popover } from "components/base";
import ForecastDetails from "components/project/forecasts/ForecastDetails";

import { USER_ARPS } from "../../constants";
import useFetchAuditForecast from "./hooks/useFetchAuditForecast";
import { ForecastWellStatus, ForecastingChangeRecord } from "./models/forecastWell";

export interface ForecastChangeRecordsModel {
  forecastId: string;
  status: ForecastWellStatus;
  declineType: string;
}

export const ForecastingChangeRecords = function ({
  forecastId,
  status,
  declineType
}: ForecastChangeRecordsModel) {
  const loading = false;
  const { data: changeRecords } = useFetchAuditForecast(forecastId, status);

  function getListItem(changeRecord: ForecastingChangeRecord) {
    const changeDate = new Date(changeRecord.changedDate);
    return (
      <Popover
        placement="bottomLeft"
        content={
          <ForecastDetails
            arpsItem={{
              arps: changeRecord.newForecast.segments,
              folderId: null,
              folderName: null,
              reserveCategory: null,
              title: forecastId,
              source: null,
              wellData: null,
              constants: changeRecord.newForecast.constants,
              id: null,
              isFolder: null,
              key: null,
              uniqueID: null,
              isChecked: null,
              children: null,
              forecastArray: null,
              color: null,
              thickness: null,
              type: null,
              projectId: null
            }}
            declineType={declineType}
            getTitle={(item) => item.title}
            type={USER_ARPS}
            hasTypeWellSaved={false}
          />
        }>
        <List.Item key={changeRecord.id}>
          <List.Item.Meta
            title={
              changeRecord.changedBy.fullName +
              " " +
              changeDate.toLocaleDateString() +
              " " +
              changeDate.toLocaleTimeString() +
              " "
            }
            description={
              <CommentContainer>
                <CommentIcon path={mdiMessageOutline} size={1.5} />
                <>{changeRecord.comment}</>
              </CommentContainer>
            }
          />
        </List.Item>
      </Popover>
    );
  }

  return (
    <>
      {loading ?? <BusyIndicator />}
      {!loading && (
        <ListWrapper>
          <List
            dataSource={changeRecords ? [...changeRecords].reverse() : []}
            renderItem={(item) => getListItem(item)}
          />
        </ListWrapper>
      )}
    </>
  );
};

const ListWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
`;

const CommentIcon = styled(Icon)`
  margin: 5px;
`;

const CommentContainer = styled.div`
  display: grid;
  grid-template-columns: 40px auto;
  align-items: center;
`;
